import { ADRestoration } from '@/client/accounts/types';
import { AppButton } from '@/ui/buttons';
import { FlexContainer } from '@/ui/styled-ui';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';

type ADRestorationsConfirmDialogProps = {
  restorations: ADRestoration[];
  visible: boolean;
  onConfirm: () => void;
  onOverwrite: () => void;
  onClose: () => void;
};

export const ADRestorationsConfirmDialog: React.FC<
  ADRestorationsConfirmDialogProps
> = ({ restorations, visible, onConfirm, onOverwrite, onClose }) => {
  const { t } = useTranslation();

  const footer = (
    <FlexContainer justify="flex-start" gap="0.5rem">
      <AppButton
        label={t('azure.conflicts.sync.resurrect')}
        severity="success"
        onClick={onConfirm}
      />
      <AppButton
        label={t('azure.conflicts.sync.overwrite')}
        severity="warning"
        onClick={onOverwrite}
      />
    </FlexContainer>
  );

  return (
    <Dialog
      draggable={false}
      visible={visible}
      header={t('azure.conflicts.dialog.title', {
        count: restorations.length,
      })}
      modal
      footer={footer}
      onHide={onClose}
      style={{ width: '700px' }}
    >
      <p className="mt-0">{t('azure.restorations.dialog.message')}</p>
      <DataTable value={restorations} size="small">
        <Column
          header={t('azure.restorations.username')}
          body={(row: ADRestoration) => row.username}
        />
        <Column
          header={t('azure.restorations.email')}
          body={(row: ADRestoration) => row.email}
        />
        <Column
          header={t('azure.restorations.displayName')}
          body={(row: ADRestoration) => row.displayName}
        />
      </DataTable>
    </Dialog>
  );
};
